import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

export function NotFoundPage() {
  return (
    <div className="state-page not-found">
      <span aria-hidden="true">404</span>
      <h1>Esa ventana no existe.</h1>
      <p>Quizá el enlace cambió o la luz ya se apagó.</p>
      <Link className="button button-light" to="/"><ArrowLeft aria-hidden="true" /> Volver al inicio</Link>
    </div>
  );
}
